import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Tag,
  Switch
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import ProductBrandPic from '../../../assets/images/price-books.png'
import Pricebookpic from '../../../assets/images/price-books-discount .png'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  getDecryptID
} from '../../../appRedux/actions/GlobalMethods'
import { PRICEBOOK } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
// import { REACT_APP_BUS_FIRST_NAME } from '../../../constants/StoreSetting'
import { env } from '../../../env'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
 


const { REACT_APP_BUS_FIRST_NAME } = env
const Panel = Collapse.Panel

const PriceListing = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const confirm = Modal.confirm
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = React.useState(true)
  const [getTableData, setTableData] = React.useState([])
  const [isLoadingTable, setIsLoadingTable] = React.useState(false)
  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const columns = [
    {
      title: <IntlMessages id='products.pricebook.pricebookname' />,
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        let url = ''
        if (record.name && record.name.includes('General Price Book')) {
          url = `/Dashboard/products/pricebook/generalpricebook/${record.key}`
        } else {
          url = `/Dashboard/products/pricebook/customprices/${record.key}`
        }
        return (
          <span
            onClick={() => {
              history.push(url)
            }}
            className='gx-link'
            style={{ fontWeight: '500' }}
          >
            {text}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.pricebook.customergroup' />,
      dataIndex: 'customergroup',
      key: 'customergroup'
    },
    {
      title: <IntlMessages id='products.pricebook.outlet' />,
      dataIndex: 'outlet',
      key: 'outlet'
    },
    {
      title: <IntlMessages id='products.pricebook.validfrom' />,
      dataIndex: 'validfrom',
      key: 'validfrom'
    },
    {
      title: <IntlMessages id='products.pricebook.validto' />,
      dataIndex: 'validto',
      key: 'validto'
    },
    {
      title: <IntlMessages id='products.main.add.sellonpos' />,
      key: 'isActiveOnSale',
      render: (text, record) => (
        <span>
          {' '}
          <Switch
            checked={record.isActiveOnSale}
            onChange={e => showStatusConfirm(e, record, "IsActiveOnSale")}
            disabled={getIsDisableDelete}
          />
        </span>
      )
    },
    {
      title: <IntlMessages id='products.pricebook.createdat' />,
      dataIndex: 'createdat',
      key: 'createdat'
    },
    {
      title: <IntlMessages id='products.brands.edit' />,
      key: 'edit',
      render: (text, record) => {
        let url = ''
        if (record.name && record.name.includes('General Price Book')) {
          url = `/Dashboard/products/pricebook/generalpricebook/${record.key}`
        } else {
          url = `/Dashboard/products/pricebook/customprices/${record.key}`
        }
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a onClick={() => history.push(url)} className='pen-edit'>
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    }
  ]

  React.useEffect(() => {
    dispatch(setCommonConfigs(PRICEBOOK))
    getListingTableData(getPagination)
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function showStatusConfirm (e, record,type) {

    const action = record.isActiveOnSale ? "deactivate" : "activate";
    const context = type === "IsActive" ? "" : " on sale";
    const title = `Are you sure you want to ${action} this pricebook ${context} on sale?`;
    
    confirm({
      title: title,
      content: `"${record.name}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        handleChageProductStatus(e, record.key)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }
  
  const handleChageProductStatus = (status, id) => {
    let body = {
      PriceBookID : id,
      IsActive : status
    };
    postPricebookStatus(body);
  }
  
  async function postPricebookStatus(body) {
    //setLoader(true);
    await ds.postPricebookStatusData(body, BEHAVIOUR_TYPE.POST)
      .then(res => {
        if (res.data.data.isUpdated) {
          message.success(res.data.data.message)
          // window.location.reload();
              let updatedProducts = getTableData.map(pricebook => {
                  if (getDecryptID(pricebook.key)  === getDecryptID(body.PriceBookID)) {
                      return { ...pricebook, isActiveOnSale: body.ProductStatus };
                  }
                  return pricebook;
              });
              setTableData(updatedProducts);
        } else {
          message.error(res.data.data.message)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        message.error('Something went wrong...')
      })
  }

  async function getListingTableData (body) {
    const getBookListingData = ds.getPriceBookData(body, BEHAVIOUR_TYPE.GET)
    await getBookListingData
      .then(res => {
        setIsLoading(false)
        setIsLoadingTable(false)
        if (res.data.data.priceBooks) {
          let mapped = res.data.data.priceBooks.map(books => {
            return {
              key: books.priceBookID,
              name: books.bookName,
              customergroup: books.customerGroupName,
              outlet: books.outletName,
              validfrom: books.validFromDate,
              validto: books.validToDate,
              createdat: books.createdAtDate,
              createdon: books.createdAt,
              isActiveOnSale :books.isActive
            }
          })
          let paginationobj = {
            CurrentPageNo: res.data.data.priceBooks[0].currentPageNo,
            PageSize: res.data.data.priceBooks[0].pageSize,
            total: res.data.data.priceBooks[0].totalRecords,
            showSizeChanger: true
          }
          setPagination(paginationobj)
          mapped.sort((a, b) => (a.createdon < b.createdon ? 1 : -1))
          let indexOfGeneralBook = mapped.findIndex(a =>
            a.name.includes('General Price Book')
          )
          if (indexOfGeneralBook != -1) {
            moveArrayItemToNewIndex(mapped, indexOfGeneralBook, 0)
          }
          setTableData(mapped)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        setIsLoadingTable(false)
      })
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function moveArrayItemToNewIndex (arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1
      while (k--) {
        arr.push(undefined)
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
    return arr
  }

  function addBook () {
    history.push('/Dashboard/products/pricebook/addbook')
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setIsLoadingTable(true)
    var body = getPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    getListingTableData(body)
  }

  return getIsAllowRead ? (
    <div className='Content-wrapper PriceBooks-pg'>

<Row className='align-items-center justify-content-center mb-3 PriceBooks-header'>
     <Col lg={12} md={12} sm={24} xs={24}>
        <h1 className='mb-0'>
            <IntlMessages id='products.pricebook.pricebooks' />
          </h1>
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <div className='pg-header-btn'>
             <Button
              className='dk-btn-add'
              type='primary'
              onClick={addBook}
              size='large'
              disabled={getIsDisableCreate}
            >
              <IntlMessages id='products.pricebook.addpricebook' />
            </Button>
          </div>
        </Col>
      </Row>


      <Card className='gx-card' title=''>
        <Collapse>
          <Panel
            className='custom-promolist-help'
            showArrow={false}
            header={<IntlMessages id='products.pricebook.needhelpheading' />}
          >
            <Row>
              <div className='billing-main'>
                <Col className='custom-promolist-helpdesc' md={12}>
                  <p>
                    <IntlMessages id='products.pricebook.helpdesc1' />
                  </p>
                  <p>
                    <IntlMessages id='products.pricebook.helpdesc2' />
                  </p>
                  <p>
                    <IntlMessages id='products.pricebook.helpdesc3' />
                  </p>
                  <p>
                    <IntlMessages id='products.pricebook.helpdesc4' />
                  </p>
                </Col>
                <Col md={12}>
                  <img src={ProductBrandPic} alt='' />
                </Col>
              </div>
            </Row>
          </Panel>
        </Collapse>
      </Card>

      
        <Card className=''>
          <Row>
            <Col md={4}>
              <img src={Pricebookpic} alt='' />
            </Col>
            <Col md={20}>
              <h1>
                <IntlMessages
                  id='products.pricebook.desc1'
                  values={{
                    strong: chunks => <strong>{chunks}</strong>,
                    bus_name_first: REACT_APP_BUS_FIRST_NAME
                  }}
                />
              </h1>
              <p>
                <IntlMessages
                  id='products.pricebook.desc2'
                  values={{
                    strong: chunks => <strong>{chunks}</strong>,
                    bus_name_first: REACT_APP_BUS_FIRST_NAME
                  }}
                />
              </p>
              <a onClick={() => history.push('/dashboard/products/promotions')}>
                <IntlMessages id='products.pricebook.desc3' />
              </a>
            </Col>
          </Row>
        </Card>
     

        <div className="tab-body-parent">
        <Card>
          {isLoading ? (
            <Skeleton count={5} height={25} />
          ) : (
            <Table
              className='gx-table-responsive'
              columns={columns}
              dataSource={getTableData}
              loading={isLoadingTable}
              pagination={getPagination}
              onChange={handleTableChange}
              // rowKey={(record) => record.key}
            />
          )}
        </Card>
        </div>
     


    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default PriceListing
